import React from 'react';
import { getContext, I18n } from '@fiverr-private/fiverr_context';
import { StatusToast } from '@fiverr-private/orca';

/**
 * Raise general error toast.
 *
 * This utility is designed to be used **only** within a component context.
 */
const raiseError = (msgKey = 'collections_perseus.errors.general') => {
    const { locale } = getContext();

    const message = <I18n k={msgKey} locale={locale} />;

    StatusToast.raise({
        message,
        theme: StatusToast.THEMES.ERROR,
    });
};

export default raiseError;
